module.exports = __webpack_public_path__ + "media/images/lp/1/history1-pc-c501232355cbf7482ec8afebd84da939.jpg";